module.exports = __webpack_public_path__ + "static/media/empty-notifications-img.2c2b40b4.png";